import { ReferenceSelectInput, Toolbar } from "ra-friendsofbabba";
import { SimpleForm, required } from "react-admin";

import FileInput from "./inputs/FileInput";
import React from "react";

const Form = (props) => {
  const { record } = props;
  return (
    <SimpleForm
      {...props}
      initialValues={{ ...record }}
      toolbar={
        <Toolbar
          backTab={3}
          backReferenceTarget="user_output_id"
          backReference="user-outputs"
        />
      }
    >
      <ReferenceSelectInput
        source="user_output_media_type_id"
        reference="user-output-media-types"
        optionText="media_type"
        validate={required()}
      />
      <FileInput source="media" validate={required()} />
    </SimpleForm>
  );
};
export default Form;
